import PermissionGuard from 'components/Global/PermissionGuard'; 
import CostCenterComponent from 'components/Settings/Masters/CostCenter';
export const CostCenter = () => {
	return (
		<PermissionGuard permission="Allow_Cost_Center">
			<CostCenterComponent />
		</PermissionGuard>
	);
};
